import React from 'react';
import CC from 'react-cookie-consent';
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies';
import { useLocation } from '@reach/router';
import { color } from '../theme';
import { vr } from '../utils';

const hideOnDev = process.env.NODE_ENV === 'development';

export const CookieConsent = () => {
  const location = useLocation();

  return (!hideOnDev ? (
    <CC
      location="none"
      buttonText="Accepter alle"
      declineButtonText="Kun nødvendige"
      buttonClasses="btn yellow-fill"
      cookieName="accept-cookies"
      enableDeclineButton
      declineButtonClasses="btn lightgray-fill"
      style={{
        display: 'block',
        position: 'fixed',
        top: '50%',
        left: '50%',
        bottom: 'auto',
        right: 'auto',
        width: '80vw',
        transform: 'translate(-50%,-50%)',
        maxWidth: 600,
        background: color.cream,
        color: color.black,
        boxShadow: '0 0 0 100vw rgba(0,0,0,.5)',
        padding: vr(1),
        textAlign: 'center',
      }}
      onAccept={() => initializeAndTrack(location)}
      disableButtonStyles
      buttonStyle={{ margin: vr(0.5) }}
    >
      <h1 style={{ textAlign: 'center', display: 'block' }}>Vi bruger cookies</h1>
      <p>
        Vi bruger cookies til at give dig den bedste oplevelse.<br />
        Når du klikker ‘Accepter alle’, giver du accept til brug af cookies.
      </p>
    </CC>
  ) : <span />);
};
